<template>
    <div>
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog
                as="div"
                class="fixed inset-0 z-40 flex md:hidden"
                @close="sidebarOpen = false"
            >
                <TransitionChild
                    as="template"
                    enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay
                        class="fixed inset-0 bg-gray-600 bg-opacity-75"
                    />
                </TransitionChild>
                <TransitionChild
                    as="template"
                    enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full"
                    enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leave-from="translate-x-0"
                    leave-to="-translate-x-full"
                >
                    <div
                        class="relative flex w-full max-w-xs flex-1 flex-col bg-gray-800 pb-4 pt-5"
                    >
                        <TransitionChild
                            as="template"
                            enter="ease-in-out duration-300"
                            enter-from="opacity-0"
                            enter-to="opacity-100"
                            leave="ease-in-out duration-300"
                            leave-from="opacity-100"
                            leave-to="opacity-0"
                        >
                            <div class="absolute right-0 top-0 -mr-12 pt-2">
                                <button
                                    type="button"
                                    class="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                    @click="sidebarOpen = false"
                                >
                                    <span class="sr-only">Close sidebar</span>
                                    <XMarkIcon
                                        class="h-6 w-6 text-white"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                        </TransitionChild>
                        <div class="flex flex-shrink-0 items-center px-4">
                            <img
                                class="h-8 w-auto"
                                src="https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg"
                                alt="Workflow"
                            />
                        </div>
                        <div class="mt-5 h-0 flex-1 overflow-y-auto">
                            <nav class="space-y-1 px-2">
                                <!--                                <router-link-->
                                <!--                                    v-for="item in navigation"-->
                                <!--                                    :key="item.name"-->
                                <!--                                    :to="item.route"-->
                                <!--                                    :class="[-->
                                <!--                                        item.current-->
                                <!--                                            ? 'bg-gray-900 text-white'-->
                                <!--                                            : 'text-gray-300 hover:bg-gray-700 hover:text-white',-->
                                <!--                                        'group flex items-center rounded-md px-2 py-2 text-base font-medium',-->
                                <!--                                    ]"-->
                                <!--                                >-->
                                <!--                                    <component-->
                                <!--                                        :is="item.icon"-->
                                <!--                                        :class="[-->
                                <!--                                            item.current-->
                                <!--                                                ? 'text-gray-300'-->
                                <!--                                                : 'text-gray-400 group-hover:text-gray-300',-->
                                <!--                                            'mr-4 h-6 w-6 flex-shrink-0',-->
                                <!--                                        ]"-->
                                <!--                                        aria-hidden="true"-->
                                <!--                                    />-->
                                <!--                                    {{ item.name }}-->
                                <!--                                </router-link>-->
                            </nav>
                        </div>
                    </div>
                </TransitionChild>
                <div class="w-14 flex-shrink-0" aria-hidden="true">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div class="hidden md:fixed md:inset-y-0 md:flex md:w-48 md:flex-col">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex min-h-0 flex-1 flex-col bg-gray-800">
                <div
                    class="flex h-16 flex-shrink-0 items-center bg-gray-900 px-4"
                >
                    <img
                        class="h-8 w-auto"
                        src="https://d2ucq9llvgnbyn.cloudfront.net/signature-white.png"
                        alt="Workflow"
                    />
                </div>
                <div class="flex flex-1 flex-col overflow-y-auto">
                    <nav class="flex-1 space-y-1 px-2 py-4">
                        <div
                            v-if="!permissions"
                            v-for="item in navigation"
                            class="font-small group flex animate-pulse items-center rounded-md px-1 py-1 text-sm"
                        >
                            <div
                                class="h-5 w-5 animate-pulse rounded-full bg-gray-500"
                            ></div>
                            <div
                                class="ml-4 h-2 flex-grow animate-pulse rounded bg-gray-500"
                            ></div>
                        </div>
                        <router-link
                            v-else
                            v-for="item in navigation"
                            :key="item.name"
                            :to="item.route"
                            class="font-small group flex items-center rounded-md px-1 py-1 text-sm"
                            active-class="text-white text-gray-300 bg-gray-900 hover:bg-gray-700 hover:text-white"
                            :class="[
                                item.prefix && isRouteActive(item.prefix)
                                    ? 'bg-gray-900 text-white'
                                    : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                !hasPermission(item.permission) ? 'hidden' : '',
                            ]"
                        >
                            <component
                                :is="item.icon"
                                :class="[
                                    item.current
                                        ? 'text-gray-300'
                                        : 'text-gray-400 group-hover:text-gray-300',
                                    'mr-3 h-6 w-6 flex-shrink-0',
                                ]"
                                aria-hidden="true"
                            />
                            {{ item.name }}
                        </router-link>
                    </nav>
                </div>
            </div>
        </div>
        <div class="flex w-full flex-1 flex-col md:pl-48">
            <div
                class="sticky top-0 z-10 flex h-16 w-full flex-shrink-0 bg-gray-800 shadow"
            >
                <button
                    type="button"
                    class="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                    @click="sidebarOpen = true"
                >
                    <span class="sr-only">Open sidebar</span>
                    <Bars3Icon class="h-6 w-6" aria-hidden="true" />
                </button>
                <div class="flex w-full flex-1 justify-between px-4">
                    <div class="flex w-full flex-1 bg-gray-700">
                        <form
                            class="flex w-full bg-gray-700 md:ml-0"
                            action="#"
                            method="GET"
                        >
                            <label for="search-field" class="sr-only"
                                >Search</label
                            >
                            <div
                                class="relative w-full text-gray-400 focus-within:text-gray-600"
                            >
                                <div
                                    class="pointer-events-none absolute inset-y-0 left-0 flex items-center"
                                >
                                    <MagnifyingGlassIcon
                                        class="h-5 w-5"
                                        aria-hidden="true"
                                    />
                                </div>
                                <input
                                    id="search-field"
                                    class="block h-full w-full border-transparent bg-gray-800 py-2 pl-8 pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 dark:text-white sm:text-sm"
                                    placeholder="Search"
                                    type="search"
                                    name="search"
                                />
                            </div>
                        </form>
                    </div>
                    <div class="ml-4 flex items-center md:ml-6">
                        <button
                            type="button"
                            @click="dark = !dark"
                            class="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none sm:mr-2"
                        >
                            <span class="sr-only">View notifications</span>
                            <component
                                :is="dark ? 'SunIcon' : 'MoonIcon'"
                                class="h-6 w-6"
                                aria-hidden="true"
                            />
                        </button>

                        <button
                            type="button"
                            class="rounded-full p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                            <span class="sr-only">View notifications</span>
                            <BellIcon class="h-6 w-6" aria-hidden="true" />
                        </button>

                        <!-- Profile dropdown -->
                        <Menu as="div" class="relative ml-3">
                            <div>
                                <MenuButton
                                    class="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-0"
                                >
                                    <span class="sr-only">Open user menu</span>
                                    <img
                                        class="h-8 w-8 rounded-full"
                                        :src="
                                            authUser.avatar ||
                                            'https://api.dicebear.com/7.x/initials/svg?backgroundColor=c0aede&seed=' +
                                                authUser.name
                                        "
                                        alt=""
                                    />
                                </MenuButton>
                            </div>
                            <transition
                                enter-active-class="transition duration-100 ease-out"
                                enter-from-class="transform scale-95 opacity-0"
                                enter-to-class="transform scale-100 opacity-100"
                                leave-active-class="transition duration-75 ease-in"
                                leave-from-class="transform scale-100 opacity-100"
                                leave-to-class="transform scale-95 opacity-0"
                            >
                                <MenuItems
                                    class="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                >
                                    <MenuItem
                                        v-for="item in userNavigation"
                                        :key="item.name"
                                        @click="close"
                                        v-slot="{ active, close }"
                                    >
                                        <button
                                            @click="
                                                close();
                                                item.route
                                                    ? $router.push(item.route)
                                                    : '';
                                            "
                                            v-if="item.name !== 'Sair'"
                                            active-class="bg-gray-100"
                                            class="block px-4 py-2 text-sm text-gray-700"
                                        >
                                            {{ item.name }}
                                        </button>
                                        <button
                                            v-else
                                            @click.prevent="logout"
                                            class="block px-4 py-2 text-sm text-gray-700"
                                        >
                                            Sign Out
                                        </button>
                                    </MenuItem>
                                </MenuItems>
                            </transition>
                        </Menu>
                    </div>
                </div>
            </div>

            <main class="flex-1">
                <div class="py-1">
                    <div class="mx-auto max-w-full px-4 sm:px-4">
                        <ticto-loading v-if="!permissions" />
                        <router-view v-show="permissions" />
                    </div>
                </div>
            </main>
        </div>

        <export-progress-card />
    </div>
</template>

<script>
import PermissionMixin from "../../mixins/PermissionMixin.vue";

import {
    Dialog,
    DialogOverlay,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    BanknotesIcon,
    Bars3Icon,
    BellIcon,
    ChartBarIcon,
    FolderIcon,
    InboxIcon,
    MagnifyingGlassIcon,
    UsersIcon,
    XMarkIcon,
} from "@heroicons/vue/20/solid";
import {
    AcademicCapIcon,
    ArchiveBoxIcon,
    BriefcaseIcon,
    ChartBarSquareIcon,
    ChatBubbleLeftEllipsisIcon,
    Cog8ToothIcon,
    CurrencyDollarIcon,
    DevicePhoneMobileIcon,
    ExclamationTriangleIcon,
    MegaphoneIcon,
    MoonIcon,
    ShieldCheckIcon,
    SignalIcon,
    SunIcon,
    UserGroupIcon,
    UserIcon,
    VideoCameraIcon,
    WalletIcon,
} from "@heroicons/vue/24/outline";
import { Square3Stack3DIcon } from "@heroicons/vue/24/solid";
import { mapActions, mapWritableState } from "pinia";
import ExportProgressCard from "../../components/export/ExportProgressCard.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import ColSkeleton from "../../components/layouts/skeleton/ColSkeleton.vue";
import { Store } from "../../stores/store";
import permissions from "../users/permissions/Permissions.vue";

export default {
    mixins: [PermissionMixin],
    components: {
        TictoLoading,
        ColSkeleton,
        ExportProgressCard,
        Dialog,
        DialogOverlay,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        BellIcon,
        Bars3Icon,
        MagnifyingGlassIcon,
        XMarkIcon,
        MoonIcon,
        ShieldCheckIcon,
        SunIcon,
        BanknotesIcon,
        ArchiveBoxIcon,
        UserGroupIcon,
        MegaphoneIcon,
        FolderIcon,
        BriefcaseIcon,
        ChartBarIcon,
        InboxIcon,
        ChartBarSquareIcon,
        ShieldCheckIcon,
        Square3Stack3DIcon,
        DevicePhoneMobileIcon,
        VideoCameraIcon,
        Cog8ToothIcon,
        ExclamationTriangleIcon,
        AcademicCapIcon,
        WalletIcon,
        UserIcon,
    },

    data() {
        return {
            sidebarOpen: false,
            navigation: [
                {
                    name: "Usuários",
                    route: { name: "users" },
                    icon: UsersIcon,
                    permission: "view.users",
                    prefix: "/user",
                },
                {
                    name: "Operações do Checkout",
                    route: { name: "operations.checkout" },
                    icon: ShieldCheckIcon,
                    permission: "view.audits",
                    prefix: "/operations/checkout",
                },
                {
                    name: "Compliance",
                    route: { name: "compliance" },
                    icon: ChatBubbleLeftEllipsisIcon,
                    permission: "view.users",
                    prefix: "/compliance",
                },
                {
                    name: "FDIC",
                    route: { name: "fdic.submissions" },
                    icon: BanknotesIcon,
                    permission: "view.fdic",
                    prefix: "/fdic",
                },
                {
                    name: "Auditoria",
                    route: { name: "auditoria" },
                    icon: ShieldCheckIcon,
                    permission: "view.auditoria",
                    prefix: "/auditoria",
                },
                {
                    name: "Produtos",
                    route: { name: "products" },
                    permission: "view.products",
                    icon: Square3Stack3DIcon,
                    prefix: "/product",
                },
                {
                    name: "Vendas",
                    route: { name: "orders" },
                    permission: "view.orders",
                    icon: ChartBarIcon,
                    prefix: "/order",
                },
                {
                    name: "Emails",
                    route: { name: "emails" },
                    permission: "view.emails",
                    icon: InboxIcon,
                    prefix: "/email",
                },
                {
                    name: "Setores",
                    route: { name: "sectors" },
                    permission: "manage.internal_roles",
                    icon: UserGroupIcon,
                    prefix: "/sectors",
                },
                {
                    name: "Analytics",
                    route: { name: "analytics.orders" },
                    permission: "view.analytics",
                    icon: ChartBarSquareIcon,
                    prefix: "/analytic",
                },
                {
                    name: "KYC",
                    route: { name: "kyc.dashboard" },
                    permission: "view.kyc",
                    icon: ShieldCheckIcon,
                    prefix: "/kyc",
                },
                {
                    name: "Financeiro",
                    route: { name: "finnancial.dashboard" },
                    permission: "view.bankAccounts",
                    icon: CurrencyDollarIcon,
                    prefix: "/financial",
                },
                {
                    name: "Blacklist",
                    route: { name: "blacklist.index" },
                    permission: "view.blacklist",
                    icon: XMarkIcon,
                },
                {
                    name: "Campanhas",
                    route: { name: "campaigns" },
                    permission: "view.campaigns",
                    icon: MegaphoneIcon,
                },
                {
                    name: "Vitrine",
                    route: { name: "showcase.recommended" },
                    permission: "view.showcase",
                    icon: FolderIcon,
                },
                {
                    name: "Serviços",
                    route: { name: "services" },
                    permission: "view.services",
                    icon: BriefcaseIcon,
                },
                {
                    name: "Ranking",
                    route: { name: "ranking.ranking" },
                    permission: "view.services",
                    icon: ChartBarIcon,
                },
                {
                    name: "Avisos",
                    route: { name: "notices.list" },
                    permission: "view.notices",
                    icon: ExclamationTriangleIcon,
                },
                {
                    name: "Gerentes",
                    route: { name: "account-managers" },
                    permission: "view.managers",
                    icon: AcademicCapIcon,
                },
                {
                    name: "Carteiras",
                    route: { name: "account-portfolio.next-plate" },
                    permission: "view.managers",
                    icon: WalletIcon,
                },
                {
                    name: "Mobile",
                    route: { name: "mobile" },
                    permission: "view.users",
                    icon: DevicePhoneMobileIcon,
                },
                {
                    name: "Vídeos",
                    route: { name: "videos" },
                    permission: "view.users",
                    icon: VideoCameraIcon,
                },
                {
                    name: "Release Notes",
                    route: { name: "release" },
                    permission: "view.releases",
                    icon: ArchiveBoxIcon,
                },
                {
                    name: "Configurações",
                    route: { name: "config" },
                    permission: "view.products",
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Nexus",
                    route: { name: "nexus" },
                    permission: "view.users",
                    icon: ChartBarSquareIcon,
                    prefix: "/nexus",
                },
                {
                    name: "Auditoria",
                    route: { name: "audit" },
                    permission: "view.audits",
                    icon: MagnifyingGlassIcon,
                },
                {
                    name: "Sellers",
                    route: { name: "sellers" },
                    permission: "view.audits",
                    icon: BanknotesIcon,
                },
                {
                    name: "Webhooks",
                    route: { name: "webhooks" },
                    icon: SignalIcon,
                    permission: "view.webhooks",
                    prefix: "/webhooks",
                },
                {
                    name: "Antifraude",
                    route: { name: "antifraud" },
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Traduções",
                    route: { name: "translations" },
                    permission: "view.translations",
                    icon: Cog8ToothIcon,
                },
                {
                    name: "Pix Automático",
                    route: { name: "pix-recurring-audit" },
                    icon: BanknotesIcon,
                    permission: "view.pix_recurring_audit",
                    prefix: "/pix-recurring",
                },
                // { name: "Projects", href: "#", icon: FolderIcon, current: false },
                // { name: "Calendar", href: "#", icon: CalendarIcon, current: false },
                // { name: "Documents", href: "#", icon: InboxIcon, current: false },
                // { name: "Reports", href: "#", icon: ChartBarIcon, current: false },
            ],
            userNavigation: [
                {
                    name: "Seu Perfil",
                    route: { name: "profile" },
                },
                {
                    name: "Configurações",
                    route: { name: "finnancial.dashboard" },
                },
                {
                    name: "Sair",
                    route: { name: "finnancial.dashboard" },
                },
            ],
        };
    },

    computed: {
        permissions() {
            return permissions;
        },
        ...mapWritableState(Store, [
            "authUser",
            "dark",
            "permissions",
            "token",
        ]),
        hasUser() {
            return this.authUser !== false;
        },
    },

    async mounted() {
        if (!this.authUser) {
            await this.fetchAuthUser();
        }
    },

    methods: {
        ...mapActions(Store, ["fetchAuthUser", "logout"]),
        isRouteActive(prefix) {
            if (!prefix) {
                return false;
            }
            return this.$route.path.startsWith(prefix);
        },
    },
};
</script>
